import React from 'react';
import { ATMHeader, ATMIcon } from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import { IRequest } from 'src/models/request.model';
import StatusRequest from 'src/components/atoms/status-request/status-request.component';
import styles from './flight-request-header.module.scss';

export type IProps = {
  data: IRequest;
  requestId: number;
};

const FlightRequestHeader: React.FC<IProps> = ({
  data,
  requestId,
  children,
}) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.flex}>
        <ATMIcon
          circular
          color={[1, 2, 4].includes(data.request.flightFlag) ? 'blue' : 'pink'}
          className={styles.icon}
          name={
            // eslint-disable-next-line no-nested-ternary
            [1, 6].includes(data.request.flightFlag)
              ? 'plane'
              : [2, 3].includes(data.request.flightFlag)
              ? 'wrench'
              : 'servicestack'
          }
          style={{
            boxShadow: [1, 2, 4].includes(data.request.flightFlag)
              ? '0 0 0 0.08em rgb(33, 133, 208) inset'
              : '0 0 0 0.08em rgb(224, 57, 151) inset',
          }}
        />
        <div>
          <div className={styles.flex}>
            <ATMHeader className={styles.headerText} size="medium">
              {`${
                Lang.FLIGHT_CATEGORY[
                  data?.passengerFlight?.isOldSCG ? 7 : data.request.flightFlag
                ]
              } - ${requestId}`}
            </ATMHeader>
            <StatusRequest status={data.request.requestStatus ?? undefined} />
          </div>
        </div>
      </div>
      <div className={styles.buttonBar}>{children}</div>
    </div>
  );
};

export default FlightRequestHeader;
